import { render, staticRenderFns } from "./OurWork.vue?vue&type=template&id=649c44fe"
import script from "./OurWork.vue?vue&type=script&lang=js"
export * from "./OurWork.vue?vue&type=script&lang=js"
import style0 from "./OurWork.vue?vue&type=style&index=0&id=649c44fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports